exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Colors */\n/* Sizes */\n/* Breakpoints */\n/* Mobile */\n/* Fonts */\n.errorSnackBar {\n  z-index: 99999;\n  color: white;\n  text-align: center;\n}\n.errorSnackBar p {\n    color: #fff;\n    font-weight: 400;\n}\n.errorSnackBar .v-snack__content {\n    height: auto;\n}\n", ""]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader??ref--0!./src/components/ApiErrors.vue?vue&type=style&index=0&lang=scss&
// module id = MO2v
// module chunks = 3